module.exports = __webpack_public_path__ + "assets/img/EKSElement-more.5065f4cc.svg";